import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=de2b4c20&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"
import style0 from "./SocialIcons.vue?vue&type=style&index=0&id=de2b4c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.98.0__lodash@4._28343674ad8f8d6f519c68f22b7bf6a1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2b4c20",
  null
  
)

export default component.exports